(() => {
  const PANEL_ID = 'nwc-size-guide';
  const focusReturn = { el: null };
  let loadedUrl = null;
  let loading = false;

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function getPanel() { return qs('#' + PANEL_ID); }
  function getBackdrop() { return qs('[data-sg-backdrop]'); }
  function getContentHost() { return qs('[data-sg-content]', getPanel()); }

  function trapFocus(e) {
    const panel = getPanel();
    if (!panel || !panel.classList.contains('is-open')) return;
    if (e.key !== 'Tab') return;
    const focusables = qsa('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])', panel)
      .filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  function bindUnits(root) {
    qsa('.nwc-sg-units button', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const unit = btn.getAttribute('data-unit');
        qsa('.nwc-sg-units button', root).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        qsa('.nwc-sg-table [data-in]', root).forEach((td) => {
          td.textContent = unit === 'cm' ? td.getAttribute('data-cm') : td.getAttribute('data-in');
        });
        qsa('.u-label', root).forEach((el) => { el.textContent = '(' + unit + ')'; });
        const table = qs('.nwc-sg-table', root);
        if (table) table.setAttribute('data-unit', unit);
      });
    });
  }

  async function loadContent(url) {
    const host = getContentHost();
    if (!host || !url) return;
    if (loadedUrl === url && host.dataset.loaded === '1') return;
    loading = true;
    host.innerHTML = '<p class="nwc-sg-loading">Loading size guide…</p>';
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('[data-nwc-size-guide]');
      if (content) {
        host.innerHTML = content.innerHTML;
      } else {
        // Fallback page (combined /pages/size-guide): pull main content if possible
        const main = doc.querySelector('main .rte, main .shopify-policy__body, main .page-content, main') || doc.body;
        host.innerHTML = '<div class="nwc-sg-fallback">' + (main ? main.innerHTML : '<p class="nwc-sg-error">Size guide unavailable.</p>') + '</div>';
      }
      bindUnits(host);
      host.dataset.loaded = '1';
      loadedUrl = url;
    } catch (err) {
      host.innerHTML = '<p class="nwc-sg-error">Sorry — we could not load the size guide. <a href="/pages/contact">Contact the NWC Team</a>.</p>';
      host.dataset.loaded = '0';
    } finally {
      loading = false;
    }
  }


  function ensurePortaled() {
    const panel = getPanel();
    const backdrop = getBackdrop();
    if (!panel || !backdrop) return;
    // Escape section stacking contexts / transforms so fixed + z-index beat the sticky header.
    if (backdrop.parentElement !== document.body) document.body.appendChild(backdrop);
    if (panel.parentElement !== document.body) document.body.appendChild(panel);
  }

  function openPanel(trigger) {
    ensurePortaled();
    const panel = getPanel();
    const backdrop = getBackdrop();
    if (!panel || !backdrop) return;
    focusReturn.el = trigger || document.activeElement;
    const url = (trigger && trigger.getAttribute('data-sg-url')) || panel.getAttribute('data-sg-default-url') || '/pages/size-guide';
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-sg-locked');
    const closeBtn = qs('[data-sg-close]', panel);
    closeBtn && closeBtn.focus();
    loadContent(url);
  }

  function closePanel() {
    const panel = getPanel();
    const backdrop = getBackdrop();
    if (!panel) return;
    panel.classList.remove('is-open');
    backdrop && backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-sg-locked');
    if (focusReturn.el && typeof focusReturn.el.focus === 'function') focusReturn.el.focus();
  }

  function onDocClick(e) {
    const openBtn = e.target.closest('[data-sg-open]');
    if (openBtn) {
      e.preventDefault();
      openPanel(openBtn);
      return;
    }
    if (e.target.closest('[data-sg-close]')) {
      e.preventDefault();
      closePanel();
      return;
    }
    if (e.target.matches('[data-sg-backdrop]')) closePanel();
  }

  function onKey(e) {
    if (e.key === 'Escape' && getPanel()?.classList.contains('is-open')) {
      e.preventDefault();
      closePanel();
    }
    trapFocus(e);
  }

  // Swipe-down close on mobile sheet handle/header
  function setupSwipe() {
    const panel = getPanel();
    if (!panel) return;
    let startY = null;
    const head = qs('.nwc-sg-head', panel) || panel;
    const handle = qs('.nwc-sg-handle', panel);
    [head, handle].filter(Boolean).forEach((el) => {
      el.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; }, { passive: true });
      el.addEventListener('touchend', (e) => {
        if (startY == null) return;
        const dy = e.changedTouches[0].clientY - startY;
        if (dy > 64) closePanel();
        startY = null;
      }, { passive: true });
    });
  }

  document.addEventListener('click', onDocClick);
  document.addEventListener('keydown', onKey);
  function onReady() {
    ensurePortaled();
    setupSwipe();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
